import React, { createContext, useContext, useState, useCallback } from "react";
import { STRINGS } from "@/i18n/strings";

// Register languages here. Swahili can be added later once content is reviewed.
export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "sw", label: "Kiswahili", short: "SW" },
];

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("maqam_lang") || "en");

  const setLang = useCallback((code) => {
    setLangState(code);
    localStorage.setItem("maqam_lang", code);
  }, []);

  // Localize a bilingual object like { en, fr }. Falls back to English.
  const L = useCallback(
    (obj) => {
      if (obj == null) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] ?? obj.en ?? Object.values(obj)[0] ?? "";
    },
    [lang]
  );

  // Translate a UI string key.
  const t = useCallback(
    (key) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key,
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, L, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
